<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >

    <div>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

<!--            <b-col-->
<!--                cols="12"-->
<!--                md="2"-->
<!--                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"-->
<!--            >-->
<!--              <label>نمایش</label>-->
<!--              <v-select-->
<!--                  v-model="perState"-->
<!--                  :options="perStateOptions"-->
<!--                  :reduce="val => val.value"-->
<!--                  :clearable="false"-->
<!--                  class="per-page-selector d-inline-block mx-50 w-50"-->
<!--              />-->
<!--              <label>وضعیت</label>-->
<!--            </b-col>-->

            <!-- Search -->
            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="جستجو بر اساس نام..."
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>ترتیب مقدار کیف پول</label>
              <v-select
                  v-model="sort"
                  :options="sortOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>ترتیب تاریخ</label>
              <v-select
                  v-model="lastUpdate"
                  :options="lastUpdateOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col
                cols="12"
                md="3"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="credit"
                    class="d-inline-block mr-1"
                    placeholder="جستجو بر اساس مقدار شارژ..."
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>تعداد</label>
              <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-md-0"
            >
              <b-button
                  variant="success"
                  class=""
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="downloadFile"
              >
                دانلود اکسل لیست
              </b-button>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mt-0 mt-md-2"
            >
              <span>مبلغ کل موجودی‌ها:</span>
              <span class="ml-1">{{ Intl.NumberFormat().format(sum) }} تومان</span>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="wallets"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >

          <template #cell(name)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :src="`https://api.rahazarei.com/${data.item.userInfo.selfieFileData}`"
                    :variant="`success`"
                    :to="{ name: 'apps-users-edit', params: { id: data.item.userInfo.userId } }"
                />
              </template>
              <b-link
                  :to="{ name: 'apps-users-edit', params: { id: data.item.userInfo.userId } }"
                  class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.userInfo.name + ' ' + data.item.userInfo.familyName }}
              </b-link>
              <small class="text-muted">@{{ data.item.userId }}</small>
            </b-media>
          </template>

          <!-- Column: walletId -->
          <template #cell(walletId)="data">
            <b-badge
                pill
                class="text-capitalize"
                :variant="``"
            >
              {{ data.item.walletId }}
            </b-badge>
          </template>

          <!-- Column: credit -->
          <template #cell(credit)="data">
            <span>
               {{ makePrettyPrice(data.item.credit) }}
            </span>
          </template>

          <!-- Column: updateDate -->
          <template #cell(updateDate)="data">
            <span>
              {{ data.item.updateDate.slice(11, 16) }}
              -
              {{ createJalaliDate(data.item.updateDate.slice(0, 10)) }}
            </span>
          </template>

          <!-- Column: state -->
          <template #cell(userInfo.state)="data">
            <b-badge
                v-if="data.item.userInfo.state === 1"
                pill
                class="text-capitalize"
                :variant="`success`"
            >
              وارد شده
            </b-badge>
            <b-badge
                v-else-if="data.item.userInfo.state === 2"
                pill
                class="text-capitalize"
                :variant="`warning`"
            >
              فالو نکرده
            </b-badge>
            <b-badge
                v-else-if="data.item.userInfo.state === 3"
                pill
                class="text-capitalize"
                :variant="`danger`"
            >
              آیدی اشتباه
            </b-badge>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">


            <b-link :to="{ name: 'apps-financial-wallets-info', params: { id: data.item.userId } }">
              <feather-icon icon="EditIcon" size="20"/>
            </b-link>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <QueriedPagination v-if="totalCounts" v-model="currentPage" :total-counts="totalCounts"
                                 :per-page="perPage"></QueriedPagination>
            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BFormInput,
  BLink,
  BMedia,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {WalletGetAllRequest} from "@/libs/Api/Wallet";
import Helper from "@/libs/Helper";
import {getUserData} from "@/auth/utils";
import axiosIns from "@/libs/axios";
import {saveAs} from 'file-saver';
import QueriedPagination from "@/views/components/QueriedPagination.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "WalletsList",
  title: "لیست موجودی ها - پنل ادمین لنزآوا",
  data() {
    return {
      wallets: null,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {key: 'name', label: 'اطلاعات کاربر'},
        {key: 'userInfo.nationalId', label: 'کد ملی'},
        {key: 'userInfo.mobile', label: 'موبایل'},
        {key: 'userInfo.state', label: 'وضعیت کاربر'},
        {key: 'walletId', label: 'شناسه کیف پول'},
        {key: 'credit', label: 'موجودی(تومان)'},
        {key: 'updateDate', label: 'آخرین تغییر'},
        {key: 'actions', label: 'جزییات و ویرایش کیف پول'},
      ],
      searchQuery: '',
      perState: '',
      perStateOptions: [
        {label: 'همه', value: ''},
        {label: 'وارد شده', value: 1},
        {label: 'فالو نکرده', value: 2},
        {label: 'آیدی اشتباه', value: 3}
      ],
      sortOptions: [
        {label: 'پیشفرض', value: ''},
        {label: 'صعودی', value: 1},
        {label: 'نزولی', value: 2},
      ],
      lastUpdateOptions: [
        {label: 'پیشفرض', value: ''},
        {label: 'جدیدترین', value: true},
        {label: 'قدیمی‌ ترین', value: false},
      ],
      overlay:false,
      sum:null,
      sort:'',
      lastUpdate:'',
      credit:'',
    }
  },
  async created() {
    if (this.$route.query.pageNumber) {
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getWallets()
  },
  methods: {
    refreshData() {
      this.getWallets()
    },
    async getWallets() {
      let _this = this;
      _this.overlay = true;
      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        searchCommand: _this.searchQuery,
        state: _this.perState,
        AmountType:_this.sort,
        LastUpdate:_this.lastUpdate,
        Credit:_this.credit
      }

      let walletGetAllRequest = new WalletGetAllRequest(_this);
      walletGetAllRequest.setParams(data);
      await walletGetAllRequest.fetch(function (content) {
        _this.overlay = false;
        _this.wallets = content.wallets;
        _this.totalCounts = content.walletsCount;
        _this.sum = content.sum;
      }, function (error) {
        _this.overlay = false;
        console.log(error);
      })
    },
    async downloadFile() {
      let _this = this;
      this.$store.commit('app/TOGGLE_DOWNLOAD')
      let userToken = getUserData().token;

      await axiosIns.post(`Wallet/GetExcel`, null, {
        responseType: 'blob',
      }).then(resp => {
        saveAs(resp.data, 'لیست موجودی ها.xlsx');
      }).catch((error) => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'عملیات ناموق!',
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید',
          },
        })
      }).finally(() => {
        this.$store.commit('app/TOGGLE_DOWNLOAD')
      });
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getWallets();
    },
    getQuery: function (nv, ov) {
      this.getWallets();
    },
    searchQuery: function (nv, ov) {
      this.getWallets()
    },
    sort: function (nv, ov) {
      this.getWallets()
    },
    lastUpdate: function (nv, ov) {
      this.getWallets()
    },
    credit: function (nv, ov) {
      this.getWallets()
    },
    // perState: function (nv, ov) {
    //   this.getWallets(this.perPage, this.currentPage, this.searchQuery, nv)
    // },
  },
  computed: {
    getQuery() {
      return this.$route.query
    },
  },
  components: {
    QueriedPagination,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    BOverlay,

    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
